<div id="accepted-files-popover">
  <p data-cy="accept-file-types-text">
    {{ 'i18n.requestCredit.acceptedFileTypes' | translate }}
  </p>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ul>
          <ng-container *ngFor="let fileType of fileTypesList; let i = index">
            <li *ngIf="i < 8" data-cy="less-than-eight-file-type">
              {{ fileType }}
            </li>
          </ng-container>
        </ul>
      </ion-col>

      <ion-col>
        <ul>
          <ng-container *ngFor="let fileType of fileTypesList; let i = index">
            <li *ngIf="i >= 8" data-cy="greater-or-equal-to-eight-file-type">
              {{ fileType }}
            </li>
          </ng-container>
        </ul>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
